import { PRICING_ROUTE_NAMES, PRICING_PREVIEW_KIND } from "@/apps/pricing/pricing.routes";
import { goToField } from "@/shared/utils";

export function usePricingGoTo() {
    return {
        goToHeaderField(fieldId) {
            goToField(PRICING_ROUTE_NAMES.projectHeader, PRICING_PREVIEW_KIND.pricing, fieldId);
        },
        goToVariantField(variantId, fieldId) {
            goToField(
                PRICING_ROUTE_NAMES.projectVariants,
                PRICING_PREVIEW_KIND.pricing,
                fieldId,
                "edit-variant",
                variantId
            );
        },
        goToCategoryField(categoryId, fieldId) {
            goToField(
                PRICING_ROUTE_NAMES.projectVariants,
                PRICING_PREVIEW_KIND.pricing,
                fieldId,
                "edit-category",
                categoryId
            );
        },
        goToLayoutField(fieldId) {
            goToField(PRICING_ROUTE_NAMES.projectLayout, PRICING_PREVIEW_KIND.pricing, fieldId);
        },
    };
}
